export default __webpack_public_path__ + "browser-internet-explorer.png";